/**
 *
 * @module address
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyObject,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class Address
 *
 */
export default class Address {

    /**
     *
     * @param {Object} options
     * @param {String} options.city
     * @param {String} options.country
     * @param {String} options.email
     * @param {String} options.firstName
     * @param {String} options.lastName
     * @param {String} options.line1
     * @param {String} [options.line2=undefined]
     * @param {String} [options.line3=undefined]
     * @param {String} options.postalCode
     * @param {String} options.state
     * @param {String} [options.middleName=undefined]
     * @throws {InvalidArgumentException}
     * @note params out of order with spec to keep optional params grouped or at the end
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'Address(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get city() {
                return `${this.ctor} options.city should be a String with length`;
            },
            get country() {
                return `${this.ctor} options.country should be a String with length`;
            },
            get email() {
                return `${this.ctor} options.email should be a String with length`;
            },
            get firstName() {
                return `${this.ctor} options.firstName should be a String with length`;
            },
            get lastName() {
                return `${this.ctor} options.lastName should be a String with length`;
            },
            get line1() {
                return `${this.ctor} options.line1 should be a String with length`;
            },
            get line2() {
                return `${this.ctor} options.line2 should be a String with length`;
            },
            get line3() {
                return `${this.ctor} options.line3 should be a String with length`;
            },
            get postalCode() {
                return `${this.ctor} options.postalCode should be a String with length`;
            },
            get state() {
                return `${this.ctor} options.state should be a String with length`;
            },
            get middleName() {
                return `${this.ctor} options.middleName should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { city, country, email, firstName, lastName, line1, line2, line3, middleName, postalCode } = options;
        const { state } = options;

        nonEmptyString(city, errorMessage.city, InvalidArgumentException);
        nonEmptyString(country, errorMessage.country, InvalidArgumentException);
        nonEmptyString(email, errorMessage.email, InvalidArgumentException);
        nonEmptyString(firstName, errorMessage.firstName, InvalidArgumentException);
        nonEmptyString(lastName, errorMessage.lastName, InvalidArgumentException);
        nonEmptyString(line1, errorMessage.line1, InvalidArgumentException);

        if (Check.assigned(line2)) {
            nonEmptyString(line2, line2, InvalidArgumentException);
        }

        if (Check.assigned(line3)) {
            nonEmptyString(line3, errorMessage.line3, InvalidArgumentException);
        }

        nonEmptyString(postalCode, errorMessage.postalCode, InvalidArgumentException);
        nonEmptyString(state, errorMessage.state, InvalidArgumentException);

        if (Check.assigned(middleName)) {
            nonEmptyString(middleName, errorMessage.middleName, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.city = city;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.country = country;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.email = email;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.firstName = firstName;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.lastName = lastName;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.line1 = line1;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.line2 = line2;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.line3 = line3;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.middleName = middleName;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.postalCode = postalCode;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.state = state;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/address.js